import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Vítejte na stránkách plemenné knihy SCHK", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Může docházet k občasným výpadkům vlivem nahrávání nových verzí. Za problémy se omlouváme. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " V případě problémů, chybových hlášení tam, kde nemají být, chybějících chybových hlášení, nebo jiných chyb, pište prosím na email richardpanek@email.cz ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", null, "Upozornění", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, " Nacházíte se v prostředí testovací implementace (verze) SW plemenné knihy. Po přepnutí do plného provozu nemusí být všechny funkce dostupné každému uživateli. ", -1)
const _hoisted_9 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_9))
}